import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Banner Types',
  basePath: '/banners-types',
  columns: [
    { key: 'name', label: 'Name', sortable: true },
    { key: 'mainpage', label: 'Main page', sortable: true,
      render: (v) => (/** @type {unknown} */ (v) === 1 || v === '1' || v === true) ? 'Yes' : 'No' },
    { key: 'image_type', label: 'Image type', sortable: true },
    { key: 'nonflash', label: 'Non flash', sortable: true },
    { key: 'object_type', label: 'Banners type', sortable: true },
    { key: 'rotating_type', label: 'Rotating type', sortable: true },
  ],
  fields: [
    { key: 'name', label: 'Name', type: 'text', required: true },
    { key: 'mainpage', label: 'Main page', type: 'yesno', defaultValue: 0 },
    { key: 'image_type', label: 'Image type', type: 'text' },
    { key: 'nonflash', label: 'Non flash', type: 'text' },
    { key: 'object_type', label: 'Banners type', type: 'text' },
    { key: 'rotating_type', label: 'Rotating type', type: 'text' },
  ],
});
